<template class ="main">
<div class="container">
  <div class="center">


    <div class="nav-bar">
      <p>
        <span class="parent-link"  @click="navToHome()" >Admin</span>
        <span> >> </span>
        <span> {{title}} </span>
<!--        <span> >> </span>-->
<!--        <span>Add Account</span>  -->
      </p>
    </div>
    <div v-if="'DataExport'==permission" class="textarea">
      <el-input
        type="textarea"
        :rows="10"
        placeholder="请输入账号"
        v-model="textarea"
        max="10">
      </el-input>
      <div class="button">
        <el-button type="primary" class="btn" @click='download' style="margin-right:20px"> 导出数据</el-button>
        <el-button type="primary" class="btn" @click='download2'>升级记录下载</el-button>
      </div>
    </div>
    <div v-else-if="'FileUpload'==permission" class="textarea">
      <el-form >
        <el-form-item label="上传文件">
            <el-upload
              ref="uploadButton"
              action="/api/v2.1/admin/utils/file_upload"
              :http-request="uploadFile"
              :auto-upload="false"
              :limit= 20
              :file-list="fileList"
              :on-remove="handleRemove"
              :on-exceed="handleExceed"
              :on-change="handleChange"
              :on-progress="progressA"
              >
              <el-button size="small" type="primary">选择文件</el-button>
            </el-upload>
        </el-form-item>
        <el-form-item>
        <el-button size="small" type="success" @click="submitUpload">立即上传</el-button>
       </el-form-item>
      </el-form>
    </div>
    <div v-else>
      <div v-if="noData" class="no-data">
      <p class="text">No Data</p>
      <div class="add-btn" @click="addAccount">
        <p>{{addBtnTitle}}</p>
      </div>
    </div>

    <div v-else class="account-list">
      <div class="tool-bar">
        <div class="add-btn" @click="addAccount">
          <p>{{addBtnTitle}}</p>
        </div>

        <div class="del-btn" @click="deleteAccount">
          <p>Delete</p>
        </div>
        <div style="clear: both"></div>
      </div>

<!--      <div>-->
<!--        <p>{{title}}</p>-->
<!--      </div>-->

      <div class="table-wrap">
        <table v-if="('EasyPatchLogin'==permission) || ('EasyUpdateLogin'==permission)">
          <tr class="table-head">
            <td class="col1" width="35%">
              <input type="checkbox" />
              <span>Account</span>
            </td>
           <td>
             Remark
           </td>
<!--            <td>-->
<!--              HCP-->
<!--            </td>-->
<!--            <td>-->
<!--              SW upgrade-->
<!--            </td>-->
<!--            <td>-->
<!--              HCL-->
<!--            </td>-->
<!--            <td>-->
<!--              EasyUpdate-->
<!--            </td>-->
          </tr>

          <tr v-for="(item, index) in currentPageData" class="data-row" :class="{'even': (index)%2 }">
            <td class="col1">
              <input type="checkbox"  v-model="item.check"/>
              <span>{{item.account}}</span>
            </td>
            <td class="col2" style="padding-left:0px;">
              <span>{{item.param.remark}}</span>
            </td> 

          </tr>
        </table>

        <table v-if="('FirmwareUpdateConfig'==permission)">
          <tr class="table-head">
            <td class="col1" width="35%">
              <input type="checkbox" />
              <span>SN</span>
            </td>
            <td>
              Model
            </td>
            <td>
              Version
            </td>
          </tr>

          <tr v-for="(item, index) in currentPageData" class="data-row" :class="{'even': (index)%2 }">
            <td class="col1">
              <input type="checkbox"  v-model="item.check"/>
              <span>{{item.account}}</span>
            </td>
            <td>
              {{item.device_id}}
            </td>
            <td>
              {{item.version}}
            </td>

          </tr>
        </table>

        <table v-if="('HCLConfig'==permission)">
          <tr class="table-head">
            <td class="col1" width="35%">
              <input type="checkbox" />
              <span>SN</span>
            </td>
            <td>
              Remark
            </td>
          </tr>

          <tr v-for="(item, index) in currentPageData" class="data-row" :class="{'even': (index)%2 }">
            <td class="col1">
              <input type="checkbox"  v-model="item.check"/>
              <span>{{item.account}}</span>
            </td>
            <td>
              {{item.device_id}}
            </td>
          </tr>
        </table>
        <table v-if="('HCLConfigForEasyPatch'==permission)">
          <tr class="table-head">
            <td class="col1" width="100%">
              <input type="checkbox"  v-model="checked" @click="chooseAll"/>
              <span>Account</span>
            </td>
          </tr>

          <tr v-for="(item, index) in currentPageData" class="data-row" :class="{'even': (index)%2 }">
            <td class="col1">
              <input type="checkbox"  v-model="item.check"/>
              <span>{{item.account}}</span>
            </td>
            <td>
              {{item.device_id}}
            </td>
          </tr>
        </table>
        <!--分页-->
        <div class="patientList-block">
            <img src="../../assets/arrow_right.png" :class="{'click1': currentPage == 1}" @click="prevPage">
            <span> <input v-model="currentPage" @keyup.13="go" @blur='go'> of &nbsp;&nbsp;{{totalPage}}</span>
            <img src="../../assets/arrow_left.png" :class="{'click1': currentPage == totalPage}" @click="nextPage">
        </div>
      </div>
    </div>
    </div>
    
  </div>
</div> <!--container结束-->
</template>

<script>
  import auth from '../../auth/auth'
  import qs from 'qs'
  import { config } from 'vue'
  import axios from 'axios'
  export default {
    data() {
      return {
        source: [],
        noData:true,
        accounts:[],
        permission:'',
        title:'',
        addBtnTitle:'Add',
        checked:false,
        currentPage:1,
        pageSize:11,
        totalPage:1,
        textarea:'',
        fileList: [],
        filedList:[]
      }
    },
    computed:{
      currentPageData(){
        let pa = Math.ceil(this.accounts.length / this.pageSize)
        pa = pa ==0?1:pa
        this.totalPage = pa
        let begin = (this.currentPage - 1) * this.pageSize;
        let end = this.currentPage * this.pageSize;
        this.displayTab =false
        return this.accounts.slice(begin,end);
     }
    },
    watch:{
    },
    mounted(){
      let permission = sessionStorage.getItem('account_admin_permission_value')
      let title = sessionStorage.getItem('account_admin_permission_title')
      this.permission = permission;
      this.title = title;
      //
      this.loadData()
      //
      if ('EasyPatchLogin'==permission) {
        this.title = 'EasyPatch';
      } else if ('EasyUpdateLogin'==permission) {
        this.title = 'EasyUpdate';
      }

    },
    methods: {
      // 上传文件
      uploadFile(file) {
          let fileData = new FormData();  // new formData对象
          fileData.append('files'+file.file.name, file.file);  // append增加数据
          let name =file.file.name
          let ss = axios.CancelToken.source();
          this.source.push( { 
              name: name,
              token: ss
          })
          axios({
            method: 'post',
            url: '/api/v2.1/admin/utils/file_upload',  // 后端接口地址
            headers: {'Content-Type': 'multipart/form-data;'},
            data:fileData,
            cancelToken:ss.token,
            onUploadProgress: (progressEvent) => {
              let num = progressEvent.loaded / progressEvent.total * 100 | 0;  //百分比
              file.onProgress({percent: num})     //进度条
            }
          }).then(res => {
              file.onSuccess();
            }).catch(err =>{
              this.$message.error('上传失败');
            })
      },
      submitUpload () {
        this.$refs.uploadButton.submit()// 提交调用uploadFile函数
      },
       /**     文件正在上传时的钩子    **/
      progressA (event, file) {

      },
      //移除
      handleRemove(file, fileList) {
        for(let i =0;i<this.source.length;i++){
          if(this.source[i].name===file.name){
            this.source[i].token.cancel('取消上传');
          }
        }
        this.$refs.uploadButton.abort(); //取消上传
        
        // this.$message({message: '成功移除' + file.name, type: 'success'});
      },
      // 选取文件超过数量提示
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 20 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      handleChange(file, fileList) {
        this.filedList = fileList;
      },
      // 下载
      download() {
        let inputValue =this.textarea.replace(/\n/g, ',')
        let uri ='/api/v2.1/admin/utils/HDGYTS671Q/export_data?username=' + inputValue
        window.open(uri,'_self')
      },
       // 下载
      download2() {
        let uri ='/api/v2.1/admin/utils/HDGYTS671Q/export_data?flag=update_record'
        window.open(uri,'_self')
      },
      //下一页
      nextPage(){
        if(this.currentPage ==this.totalPage) return
        this.currentPage++
      },
      //上一页
      prevPage(){
        if(this.currentPage ==1) return
        this.currentPage--
      },
      //输入页码跳转
      go(){
        if(0<this.currentPage&&this.currentPage<this.totalPage+1){
          this.currentPage =this.currentPage
        }else{
          this.currentPage = 1
        }
      },
      loadData() {
        //
        this.$http.post('/api/v2.1/account_manage/get_record', {
          permission:this.permission
        }).then(function (res) {
          let accountData = res.body.data;
          if (accountData && accountData.length>0) {
            this.noData=false;
            this.accounts=accountData;
          } else {
            this.noData=true;
            this.accounts=[];
          }
        }, function (err) {

        })
      },
      addAccount() {
        this.$router.push('/accountsadmin_add')
      },
      navToHome() {
        this.$router.push('/accountsadmin_home')
      },
      deleteAccount() {
        let accounts=[];
        accounts = this.accounts.filter(function (e,i) {
          return e.check;
        })
        accounts = accounts.map(function (e,i) {
          return e.account;
        })
        if (0==accounts.length) {
          this.$message({
            type:'warning',
            message:'Select'
          })
          return;
        }
        this.$http.post('/api/v2.1/account_manage/delete', {
          accounts:accounts,
          permission: this.permission
        }).then(function (res) {
          let error = res.body.error;
          if (error) {
            this.$message.error('code:'+error);
          } else {
            this.$message({
              type:'success',
              message:"Success"
            })
            // this.reload()
            this.loadData()
          }
        }, function (err) {
          
        })
      },
      chooseAll() {
        if(!this.checked){
          for(let i=0; i<this.accounts.length;i++){
            this.accounts[i].check = false
          }
        } else {
          for(let i=0; i<this.accounts.length;i++){
            this.accounts[i].check = true
          }
        }
      },
    },
  }
</script>

<style scoped>
  .main {
    height:100%;
    background-color:#ffffff;
  }
  .container {
    height:100%;
    background-color:#ffffff;
    min-height:689px;
  }

  .container .center {
    width: 75%;
    margin: 0 auto;
  }

  .container .center .no-data {
    padding-top: 5%;
  }

  .container .center .no-data .text {
    text-align: center;
    font-size:20px;
    *margin-top: 20%;
  }

  .container .center .add-btn {
    width:150px;
    background-color:#0c544f;
    height:30px;
    border-radius:20px;
    margin: 0 auto;
    margin-top:50px;
    cursor: pointer;
  }

  .container .center .add-btn {
    color: #fff;
    text-align: center;
    line-height: 30px;
  }

  .container .center .account-list .tool-bar {
    padding-top: 20px;
  }

  .container .center .account-list .tool-bar .add-btn {
    margin: 0;
    float:right;
  }

  .container .center .account-list .tool-bar .del-btn {
    width:100px;
    background-color:#c03c13;
    height:30px;
    border-radius:20px;
    cursor: pointer;
    float:right;
    margin-right:50px;
  }

  .container .center .account-list .tool-bar .del-btn p {
    text-align: center;
    color:#fff;
    line-height: 30px;

  }

  .account-list .table-head {
    background-color:#0c544f;
    height:40px;
    color:#fff;
  }

  .table-wrap table .data-row {
    height:40px;
  }

  .table-wrap table .data-row.even {
    background-color:#e7e7e7;
  }

  .account-list .table-wrap {
    margin-top:30px;

  }

  .account-list .table-wrap table {
    width: 100%;
    border-collapse:collapse;
    border:none;
  }

  .table-wrap table input[type="checkbox"] {
    width: 18px;
    height: 18px;
    /*background-color: red;*/
    /*-webkit-appearance:none;*/
    border: 1px solid #c9c9c9;
    border-radius: 2px;
    outline: none;
    margin-left: 10px;
    margin-top:5px;
    float: left;
  }

  .table-wrap table .col1 span {
    float: left;
    margin-left: 10px;
    margin-top: 2px;
  }

  .table-wrap table .col2 {
    padding-left: 15px;
  }

  .table-wrap table input[type="checkbox"]:checked {
    /*background: url("/static/accountadmin/icon_selected.png") no-repeat center;*/
  }

  .container .center .nav-bar {
    padding-top: 50px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
  }

  .container .center .nav-bar span{
    cursor: pointer;
  }
/*分页*/
  .patientList-block{
    margin-top:20px;
    height:20px;
    width: 208px;
    letter-spacing:-0.44px;
    bottom: 15px;
  }
  .patientList-block img{
    cursor: pointer;
    float: left;
  }
  .patientList-block span{
    float: left;
    display: block;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    text-align:left;
    margin: -2px 20px 0;
  }
  .patientList-block input{
    font-family:SFUIText-Regular;
    font-size:18px;
    height:18px;
    width:36px;
    margin-right: 20px;
    text-align: center;
  }
  .patientList-block .click1{
    opacity: 0.3;
    cursor:auto;
  }
  .textarea {
    margin-top: 20px;
    display: flex;
    flex-flow: column;
  }
  .button {
    display: flex;
    flex-flow: nowrap;
    justify-content: flex-end;
  }
  .btn {
    margin-top: 20px;
  }
  .progress-wrap {
	width: 300px;
}
.progress-wrap p {
	width: 100%;
}
.progress {
	background-color: #c5c8ce;
	height: 20px;
  margin-top: 10px;
}
.progress span {
  display: block;
	background-color: #19be6b;
	height: 100%;
	width: 0;
}
.percent-val {
  margin-left: 20px;
  background-color: #fff;
}
.cancel-btn {
  margin-top:20px
}
</style>



// WEBPACK FOOTER //
// AccountAdminList.vue?0cec2620